import React from 'react'
import { Script } from 'gatsby'
import { useInlineScriptsFromHTML } from '../hooks'

/**
 * Renders HTML and runs inline scripts after hydration.
 *
 * @param {string} html
 */
export default function HTML({ html, ...props }) {
    const [scripts, cleanHTML] = useInlineScriptsFromHTML(html)
    return (
        <>
            <div {...props} dangerouslySetInnerHTML={{ __html: cleanHTML }} />
            {scripts.map((script, i) => (
                <Script key={i}>{script}</Script>
            ))}
        </>
    )
}
